import { z } from 'zod/v4';

export const assetTypeOptions = [
  'Email',
  'Phone',
  'VehicleId',
  'DeviceId',
  'DriverId',
  'InventoryId',
] as const;

export const assetTypeSchema = z.enum(assetTypeOptions);

export type AssetType = z.infer<typeof assetTypeSchema>;
